import { compose } from 'redux';

import isTestEnvironment from 'helpers/isTestEnvironment';

export const composeWithDevTools =
  isTestEnvironment &&
  typeof window !== 'undefined' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;
